// Columnas matching bancario
export const columnasMatchingBancarioList = [
    {
        key: 'EB_FECHA',
        label: 'Fecha Mail',
        type: 'date',
        sorted: true,
    },
    {
        key: 'EB_BANCO_DES',
        label: 'Banco Mail',
        type: 'string',
        sorted: true,
        headerClassName: 'max-w-[100px]',
        cellClassName: 'max-w-[100px]'
    },
    {
        key: 'EB_CUENTA',
        label: 'Cuenta Mail',
        type: 'string',
        sorted: true,
    },
    {
        key: 'EB_IMPORTE',
        label: 'Importe Mail',
        type: 'number',
        sortKey: 'currency',
        sorted: true,
    },
    {
        key: 'EB_CARATULA',
        label: 'Carátula Embargo',
        type: 'string',
        sorted: true,
        headerClassName: 'max-w-[100px]',
        cellClassName: 'max-w-[100px]'
    },
    {
        key: 'EB_ESTADO_DESC',
        label: 'Estado Mail',
        type: 'string',
        sorted: true,
        headerClassName: 'max-w-[100px]',
        cellClassName: 'max-w-[100px]'
    },
    {
        key: 'EB_FECHA_ESTADO',
        label: 'Fecha Estado',
        type: 'date',
        sorted: true,
    },
    {
        key: 'EXT_CUENTA_NUM',
        label: 'Cuenta Ext.',
        type: 'string',
        sorted: true,
    },
    {
        key: 'EXT_FECHA_MOVIMIENTO',
        label: 'Fecha Mov. Ext.',
        type: 'date',
        sorted: true
    },
    {
        key: 'EXT_IMPORTE',
        label: 'Importe Ext.',
        type: 'number',
        sortKey: 'currency',
        sorted: true,
    },
    {
        key: 'PORC_MATCH',
        label: '% Match',
        type: 'component',
        sorted: true,
        sortKey: 'value',
    },
    {
        key: "acciones",
        label: "",
        sorted: false,
        type: "component",
        cellClassName: 'pl-[2px]',
    },
    {
        key: "ID_EMAIL",
        label: "",
        type: "number",
        hidden: true
    },
    {
        key: "EB_ESTADO_COD",
        label: "",
        type: "number",
        hidden: true
    },
    {
        key: "ULT_CIERRE_CONTABLE",
        label: "",
        type: "string",
        hidden: true
    }
];